import { ofType } from 'redux-observable';
import { filter, flatMap, map, switchMap } from 'rxjs/operators';
import { versaItRoot } from 'config.json';
import 'whatwg-fetch';

const FETCH_WORK_ORDER_TEMPLATES = 'FETCH_WORK_ORDER_TEMPLATES';
const FETCH_WORK_ORDER_TEMPLATES_COMPLETE = 'FETCH_WORK_ORDER_TEMPLATES_COMPLETE';

// Default state
const DEFAULT_STATE = {
  workOrderTemplates: []
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_WORK_ORDER_TEMPLATES_COMPLETE:
      return {
        ...state,
        workOrderTemplates: payload
      };
    default:
      return state;
  }
}

// Action creators
export const fetchWorkOrderTemplates = () => ({
  type: FETCH_WORK_ORDER_TEMPLATES
});

const fetchWorkOrderTemplatesComplete = workOrderTemplates => ({
  type: FETCH_WORK_ORDER_TEMPLATES_COMPLETE,
  payload: workOrderTemplates
});

// Epics
const fetchWorkOrderTemplatesEpic = action$ => action$.pipe(
  ofType(FETCH_WORK_ORDER_TEMPLATES),
  flatMap(jobId => {
    // Fetching the work order templates is a cross-origin request that fails locally
    if (process.env.NODE_ENV !== 'production') {
      return new Promise(() => null);
    }

    return fetch(`${versaItRoot}/JP_MVC/scheduler/work-order-templates`, {
      cache: 'no-store',
      credentials: 'include'
    });
  }),
  filter(response => response.status >= 200 && response.status < 300),
  flatMap(response => response.json()),
  map(fetchWorkOrderTemplatesComplete),
);

export const epics = fetchWorkOrderTemplatesEpic;
